import { Paper, TextLargeParagraph } from '@carboncopyco/ui';
import { ArticleCard } from './ArticleCard';
import { articles } from './consts';

export const LearningHubCard = () => {
  return (
    <Paper
      radius
      border="ds-regular"
      padding="lg"
    >
      <div className="flex flex-col gap-5">
        <TextLargeParagraph
          label="Learning hub"
          color="text-ds-natural-600"
        />
        <div className="flex flex-col gap-3">
          {articles.map((article) => (
            <ArticleCard
              key={article.href}
              {...article}
            />
          ))}
        </div>
      </div>
    </Paper>
  );
};
